import React from "react";

function Page6() {
  return (
    <div className="page-container">
      <div
        className="page"
        style={{
          width: "93%",
          height: "1209px",
          margin: "20px auto 30px auto",
          boxShadow: "0 0 2rem 0 rgba(136, 152, 170, 0.5)",
        }}
      >
        <div
          id="pg6Overlay"
          style={{
            WebkitUserSelect: "none",
            backgroundColor: "rgba(0,0,0,0)",
            height: "100%",
            position: "absolute",
            width: "100%",
            zIndex: "1",
          }}
        />
        <div
          id="pg6"
          style={{
            WebkitUserSelect: "none",
          }}
        >
          <img
            id="pdf6"
            alt="pdf6"
            src="data:image/svg+xml,%3Csvg viewBox='0 0 934 1209' version='1.1' xmlns='http://www.w3.org/2000/svg'%3E%0A%3Cdefs%3E%0A%3Cstyle%3E%0A.g0%7Bfill:none%3Bstroke:%23000%3Bstroke-width:1.527%3Bstroke-miterlimit:10%3B%7D%0A%3C/style%3E%0A%3C/defs%3E%0A%3Cpath d='M54.6 73.3H836.4m-.8 0h44.8' class='g0'/%3E%0A%3C/svg%3E"
            style={{
              height: "1209px",
              width: "98%",
            }}
          />
        </div>
        <div className="text-container">
          <span
            className="t s0"
            style={{
              bottom: "1138px",
              left: "55px",
              letterSpacing: "-0.15px",
            }}
          >
            Form W-9 (Rev. 3-2024){" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1137px",
              left: "844px",
              letterSpacing: "-0.14px",
            }}
          >
            Page{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "1135px",
              left: "872px",
            }}
          >
            6{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1106px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            Victims of identity theft who are experiencing economic harm or a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1092px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            systemic problem, or are seeking help in resolving tax problems that{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1079px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            have not been resolved through normal channels, may be eligible for{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1065px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Taxpayer Advocate Service (TAS) assistance. You can reach TAS by{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1051px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            calling the TAS toll-free case intake line at 877-777-4778 or
            TTY/TDD{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1037px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            800-829-4059.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "1019px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            Protect yourself from suspicious emails or phishing schemes.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1005px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            Phishing is the creation and use of email and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1005px",
              left: "303px",
              letterSpacing: "0.1px",
            }}
          >
            websites designed to{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "992px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            mimic legitimate business emails and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "992px",
              left: "262px",
              letterSpacing: "0.11px",
            }}
          >
            websites. The most common act{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "978px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            is sending an email to a user{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "978px",
              left: "214px",
              letterSpacing: "0.09px",
            }}
          >
            falsely claiming to be an established{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "964px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            legitimate enterprise in an{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "964px",
              left: "199px",
              letterSpacing: "0.1px",
            }}
          >
            attempt to scam the user into surrendering{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "950px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            private information{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "950px",
              left: "160px",
              letterSpacing: "0.09px",
            }}
          >
            that will be used for identity theft.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "932px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            The IRS does not initiate contacts with taxpayers via emails. Also,
            the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "918px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            IRS does not request personal detailed information through email or
            ask{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "904px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            taxpayers for the PIN numbers, passwords, or similar secret access{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "891px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            information for their credit card, bank, or other financial
            accounts.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "872px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            If you receive an unsolicited email claiming to be from the IRS,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "859px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            forward this message to{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "859px",
              left: "190px",
              letterSpacing: "0.1px",
            }}
          >
            phishing@irs.gov
          </span>
          <span
            className="t s6"
            style={{
              bottom: "859px",
              left: "282px",
              letterSpacing: "0.1px",
            }}
          >
            . You may also report misuse{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "845px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            of the IRS name, logo, or other IRS property to the Treasury
            Inspector{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "831px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            General for Tax Administration (TIGTA) at 800-366-4484. You can{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "817px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            forward suspicious emails to the Federal Trade Commission at{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "804px",
              left: "55px",
              letterSpacing: "0.12px",
            }}
          >
            spam@uce.gov{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "804px",
              left: "141px",
              letterSpacing: "0.09px",
            }}
          >
            or report them at{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "804px",
              left: "237px",
              letterSpacing: "0.11px",
            }}
          >
            www.ftc.gov/complaint
          </span>
          <span
            className="t s6"
            style={{
              bottom: "804px",
              left: "363px",
              letterSpacing: "0.09px",
            }}
          >
            . You can{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "790px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            contact the FTC at{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "790px",
              left: "160px",
              letterSpacing: "0.1px",
            }}
          >
            www.ftc.gov/idtheft{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "790px",
              left: "271px",
              letterSpacing: "0.11px",
            }}
          >
            or 877-IDTHEFT (877-438-4338).{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "776px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            If you have been the victim of identity theft, see{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "776px",
              left: "316px",
              letterSpacing: "0.11px",
            }}
          >
            www.IdentityTheft.gov{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "762px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            and Pub. 5027.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "744px",
              left: "67px",
              letterSpacing: "0.09px",
            }}
          >
            Go to{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "744px",
              left: "101px",
              letterSpacing: "0.1px",
            }}
          >
            www.irs.gov/IdentityTheft{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "744px",
              left: "244px",
              letterSpacing: "0.09px",
            }}
          >
            to learn more about identity theft and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "730px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            how to reduce your risk.{" "}
          </span>
          <span
            className="t sd"
            style={{
              bottom: "1099px",
              left: "484px",
              letterSpacing: "0.16px",
            }}
          >
            Privacy Act Notice{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "1082px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Section 6109 of the Internal Revenue Code requires you to provide
            your{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "1068px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            correct TIN to persons (including federal agencies) who are required
            to{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "1054px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            file information returns with the IRS to report interest, dividends,
            or{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "1040px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            certain other income paid to you; mortgage interest you paid; the{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "1027px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            acquisition or abandonment of secured property; the cancellation of{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "1013px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            debt; or contributions you made to an IRA, Archer MSA, or HSA. The{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "999px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            person collecting this form uses the information on the form to file{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "985px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            information returns with the IRS, reporting the above information.{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "972px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Routine uses of this information include giving it to the Department
            of{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "958px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            Justice for civil and criminal litigation and to cities, states, the
            District of{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "944px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Columbia, and U.S. commonwealths and territories for use in{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "930px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            administering their laws. The information may also be disclosed to
            other{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "917px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            countries under a treaty, to federal and state agencies to enforce
            civil{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "903px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            and criminal laws, or to federal law enforcement and intelligence{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "889px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            agencies to combat terrorism. You must provide your TIN whether or
            not{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "875px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            you are required to file a tax return. Under section 3406, payors
            must{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "862px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            generally withhold a percentage of taxable interest, dividends, and{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "848px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            certain other payments to a payee who does not give a TIN to the
            payor.{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "834px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Certain penalties may also apply for providing false or fraudulent{" "}
          </span>
          <span
            className="t v6 s6"
            style={{
              bottom: "820px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            information.{" "}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Page6;
